import { useEffect } from 'react';
import withCustomComponent from '../ui/components/withCustomComponent';
import { inject, observer } from 'mobx-react';
import { IAuthTokens } from '../env/stores/authTokens/authTokenTypes';

const CHECK_REFRESH_EVERY_S = 10;
/**
 * Takes care of refreshing tokens in the background, client side only
 */
const TokenRefresher = withCustomComponent('TokenRefresher')(
  inject('authTokens')(
    observer(
      ({
        authTokens,
        children,
      }: {
        authTokens: IAuthTokens;
        children?: React.ReactNode;
      }) => {
        // Will only actually run on the client side as it's a useEffect
        useEffect(() => {
          // Do an initial refresh when we mount, just in case
          if (authTokens.isPendingRefresh) {
            authTokens.ensureAllTokensAreReady().catch((e) => {
              console.error('Error refreshing tokens', e);
            });
          }

          const interval = setInterval(() => {
            if (authTokens.isPendingRefresh) {
              authTokens.ensureAllTokensAreReady().catch((e) => {
                console.error('Error refreshing tokens', e);
              });
            }
          }, CHECK_REFRESH_EVERY_S * 1000);

          return () => clearInterval(interval);
        }, []);

        return children || null;
      },
    ),
  ),
);

export default TokenRefresher;
